import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { Route, Routes } from 'react-router-dom'
const Content = ({ routes }) => {
  return (
    <>
      <Suspense>
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element />}
                />
              )
            )
          })}
        </Routes>
      </Suspense>
    </>
  )
}
Content.propTypes = {
  routes: PropTypes.array,
}
export default React.memo(Content)
